const comments = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20portrait%20style%2C%20soft%20lighting%2C%20neutral%20background%2C%20cinematic%20quality%2C%20elegant%20editorial%20photography&width=80&height=80&seq=avatar-2026-01&orientation=squarish',
    date: '2026-07-30',
    rating: 5,
    content: '极速影视真的太方便了！更新的速度超级快，画质也很清晰，追剧完全不用等。界面简洁没有乱七八糟的广告，体验感满分。已经推荐给身边所有追剧的朋友了！',
  },
  {
    name: '电影爱好者Leo',
    avatar: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20style%2C%20warm%20soft%20lighting%2C%20clean%20neutral%20background%2C%20professional%20photography%2C%20elegant%20composition&width=80&height=80&seq=avatar-2026-02&orientation=squarish',
    date: '2026-07-28',
    rating: 5,
    content: '作为一个重度电影迷，极速影视的片库真的让我惊喜。不仅新片上线快，经典老片也有很多高清修复版。每天晚上刷一部高分电影，生活质量直线上升。',
  },
  {
    name: '综艺控小玉',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20photography%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20editorial%20style%2C%20elegant%20and%20minimalist&width=80&height=80&seq=avatar-2026-03&orientation=squarish',
    date: '2026-07-25',
    rating: 4,
    content: '综艺频道的内容很丰富，热门节目基本都有。周末窝在沙发上一口气刷完一整季综艺，高清不卡顿体验超棒。希望能增加更多脱口秀类节目！',
  },
];

function Stars({ count }: { count: number }) {
  return (
    <span className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`text-xs ${i < count ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
        ></i>
      ))}
    </span>
  );
}

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            观众热评
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            来自真实用户的追剧体验分享
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((comment, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {comment.name}
                  </h3>
                  <span className="text-xs text-foreground-500">{comment.date}</span>
                </div>
              </div>
              <Stars count={comment.rating} />
              <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}